export default function translate(i18n, propriete) {
  if (propriete === 'tiersId') return i18n.t('remiseBancaire.ajoutReglement.clientOuCompteComptable');
  if (propriete === 'montantTtc') return i18n.t('remiseBancaire.ajoutReglement.montantTtc');
  if (propriete === 'dateReglement') return i18n.t('remiseBancaire.ajoutReglement.dateReglement');
  return propriete;
}
